import { forwardRef, type TextareaHTMLAttributes } from 'react';

import { cn } from '@/shared/lib/utils';

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

const textareaBase =
  'flex w-full rounded-[12px] border border-[#E5E7EB] bg-[#F9FAFB] px-3.5 py-2 text-sm text-foreground placeholder:text-[#9CA3AF] focus-visible:border-primary focus-visible:ring-2 focus-visible:ring-primary/20 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-60 transition-colors min-h-[80px] resize-y';

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return <textarea ref={ref} className={cn(textareaBase, className)} {...props} />;
  },
);
Textarea.displayName = 'Textarea';
